import { createAsyncThunk } from '@reduxjs/toolkit';

import Logger from '../../services/Logger';
import getThumbnailUrls from '../../helpers/getThumbnailUrls';
import prepareSearchQuery from '../../helpers/assets/prepareSearchQuery';
import { constructQueryString } from '../../helpers/history';
import { extendAssets, setThumbnailUrls } from '../helpers/assets';

const PAGE_SIZE = 50;
const DEFAULT_SORT = { type: 'uploadTime', order: 'desc' };

export const searchMediaLibraryModal = createAsyncThunk(
  'mediaLibraryModal/search',
  async ({ loadMore } = {}, { getState, extra: { sdk } }) => {
    try {
      const { query = {}, items = [] } = getState().mediaLibraryModal || {};
      const { sort, ...queryWithoutSort } = query;
      const queryString = constructQueryString({ ...queryWithoutSort }, {});
      const prepared = prepareSearchQuery(queryString);
      const from = loadMore ? items.length : 0;
      const { data } = await sdk.assets.search({
        ...prepared,
        size: PAGE_SIZE,
        from,
        sort: sort || DEFAULT_SORT,
      });

      const assets = extendAssets(data?.images || []);
      if (!assets.length) {
        return {
          items: [],
          total: data?.total || 0,
          append: Boolean(loadMore),
        };
      }

      const thumbs = await getThumbnailUrls(assets.map(({ _id }) => _id));
      const { team } = getState().user || {};

      return {
        items: setThumbnailUrls(assets, thumbs, team?.storageType === 's3'),
        total: data?.total || 0,
        append: Boolean(loadMore),
      };
    } catch (error) {
      Logger.error(error instanceof Error ? error : new Error('Media library modal search failed'), {
        error,
      }, [
        'MediaLibraryModalSearchFailed',
        { errorMessage: (error && error.message) || 'NoMessage' },
      ]);
      throw error;
    }
  },
);
